var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-ios-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"main-container markdown-container"},[_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.html)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c54d26c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/docsify/privacyIosInternational.vue
// module id = null
// module chunks = 